import ShareModalContainer from './ShareModalContainer';
export default ShareModalContainer;
